/**
 * @generated SignedSource<<31f2785fe7ba890b4cf522b7d48a9753>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OptionsMenu_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer">;
  readonly " $fragmentType": "OptionsMenu_viewer";
};
export type OptionsMenu_viewer$key = {
  readonly " $data"?: OptionsMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OptionsMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OptionsMenu_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "41a0ebc7dea55fc64c099927febb1d3d";

export default node;
